import styled from 'styled-components';

export const IconItem = styled.div`
  pointer-events: none;
  transform: translate(-50%, -50%);
  background-color: transparent;
  background-image: url(${props => props.imageUrl});
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  width: ${props => props.item.size.width * props.item.ui.scale}px;
  height: ${props => props.item.size.height * props.item.ui.scale}px;
  filter: drop-shadow(-2px 2px 2px rgba(0, 0, 0, 0.5))
    drop-shadow(-2px 2px 2px rgba(255, 255, 255, 0.5));
`;

export default IconItem;
